module.exports = __webpack_public_path__ + "static/media/Bewear_gaussian2.6ee5225a.png";